// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","getInTouchCTA":"G7b695a","heading":"Gdbbe67 Gfbbf38"};